import { YStack, ScrollView } from '@fliisi/pollen'
import React, { ComponentProps } from 'react'

interface ScreenLayoutProps extends ComponentProps<typeof ScrollView> {
  children?: React.ReactNode
  padding?: number
}

export function ScreenLayout({ children, padding = 16, ...props }: ScreenLayoutProps) {
  return (
    <YStack f={1} bg="$background">
      <ScrollView
        f={1}
        contentContainerStyle={{
          maxWidth: 768,
          alignSelf: 'center' as const,
          width: '100%',
          ...(padding ? { padding } : {}),
        }}
        showsVerticalScrollIndicator={false}
        {...props}
      >
        {children}
      </ScrollView>
    </YStack>
  )
}

ScreenLayout.Padding = 16
ScreenLayout.MaxWidth = 768

interface FullScreenLayoutProps extends ComponentProps<typeof YStack> {
  children?: React.ReactNode
}

export function FullScreenLayout({ children, ...props }: FullScreenLayoutProps) {
  return (
    <YStack f={1} bg="$background" {...props}>
      {children}
    </YStack>
  )
}
